<template>
    <div class="md-content">
        <toolbar title="Gestion des Types" />

        <div class="md-mt-5 md-layout md-gutter md-alignment-top-center ">
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <md-button class="btnHeight" :to="{ name: 'addressType_List'}" disabled>
                    <md-icon class="md-size-5x md-primary">home</md-icon>
                    <span class="text">Gestion des types d'adresses</span>
                </md-button>
                <md-button class="btnHeight" :to="{ name: 'phoneType_List'}" disabled>
                    <md-icon class="md-size-5x md-primary">phone</md-icon>
                    <span class="text">Gestion des types de téléphones</span>
                </md-button>
                <md-button class="btnHeight" :to="{ name: 'emailType_List'}" disabled>
                    <md-icon class="md-size-5x md-primary">email</md-icon>
                    <span class="text">Gestion des types de courriels</span>
                </md-button>
            </div>
            <div class="md-layout-item md-size-45 md-small-size-90 ">
                <md-button class="btnHeight" :to="{ name: 'accountType_List'}" disabled>
                    <md-icon class="md-size-5x md-primary">account_circle</md-icon>
                    <span class="text">Gestion des types de comptes</span>
                </md-button>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .btnHeight {
        height: auto;
        margin: 30px;
    }

    .text {
        text-transform: none;
    }
</style>
<script>
    import baseToolbar from '@/components/toolbarBase.vue';

    export default {
        name: 'allTypesManagement',
        components: {
            'toolbar': baseToolbar,
        }
    };
</script>
